import { useTranslation } from 'react-i18next';

export default function MapLegend() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-3 gap-4 mt-4 text-center text-sm !border !border-solid pt-2 pb-2 border-gray-400">
      <div className="flex items-center justify-center gap-2">
        <div className="w-6 h-6 bg-primaryorange"></div>
        {t('selected')}
      </div>
      <div className="flex items-center justify-center gap-2">
        <div className="w-6 h-6 bg-primaryblue"></div>
        {t('available')}
      </div>
      <div className="flex items-center justify-center gap-2">
        <div
          className="w-6 h-6"
          style={{ backgroundColor: 'rgb(221, 221, 221)' }}
        ></div>
        {t('unavailable')}
      </div>
    </div>
  );
}
